import { useState } from 'react';
import { XCircle, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

export default function RejectedAccessPage() {
  const [reapplying, setReapplying] = useState(false);
  const [reapplied, setReapplied] = useState(false);

  const handleReapply = async () => {
    setReapplying(true);
    try {
      // Redirect to Google login — the backend will detect rejected status
      // and on reapply action the user signs in again which triggers the flow
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/login`;
    } catch {
      toast.error('Something went wrong. Please try again.');
      setReapplying(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFF8F0] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-6">
          <XCircle size={32} className="text-red-500" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
        <div className="w-14 h-14 shrink-0 flex items-center justify-center">
        <img src="/tempust-logo.png" alt="Tempust" className="w-14 h-14 object-contain" />
        </div>
        
          <span className="text-[#1F1A17] font-bold text-lg tracking-tight font-outfit">Tempust</span>
        </div>

        <h1 className="text-2xl font-bold text-[#1F1A17] font-outfit mb-3">Access Not Approved</h1>
        <p className="text-[#6E6258] text-sm leading-relaxed mb-6">
          Your access request was not approved. If you think this is a mistake,
          you can reapply and an admin will review your request again.
        </p>

        {reapplied ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-6 py-4 mb-6">
            <p className="text-emerald-700 text-sm font-medium">Reapplication submitted</p>
            <p className="text-[#6E6258] text-xs mt-1">An admin will review your request shortly.</p>
          </div>
        ) : (
          <button
            onClick={handleReapply}
            disabled={reapplying}
            className="w-full flex items-center justify-center gap-2 bg-[#1F1A17] hover:bg-[#2B241F] disabled:opacity-50 text-[#FFE4C4] font-medium text-sm py-3 px-6 rounded-xl transition-colors mb-4"
          >
            <RotateCcw size={16} className={reapplying ? 'animate-spin' : ''} />
            {reapplying ? 'Submitting...' : 'Reapply for Access'}
          </button>
        )}

        <p className="text-[#9C8E84] text-xs">
          If you continue to have issues, contact your administrator directly.
        </p>

        <button
          onClick={() => window.location.href = '/login'}
          className="mt-4 text-xs text-[#9C8E84] hover:text-[#6E6258] transition-colors underline underline-offset-2"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}